import * as React from 'react';

import type { QuantityUnitType } from '@acceligentllc/shared/enums/quantityUnit';

import styles from '../styles.module.scss';

type Props = {
	name: string;
	onValueChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	value: Nullable<number>;
	unit: Nullable<QuantityUnitType>;
	label?: string;
};

const NonCompoundField: React.FC<Props> = ({ name, onValueChange, value, unit, label }) => {
	return (
		<>
			{label}
			<div className={styles['numeric-field__single']}>
				<input
					className="form-control"
					onChange={onValueChange}
					placeholder={name}
					type="number"
					value={value ?? undefined}
				/>
				{unit && (
					<span className={styles['numeric-field__unit']}>
						{unit}
					</span>
				)}
			</div>
		</>
	);

};

export default React.memo(NonCompoundField);

